<div class="tw-relative">
    <button
        data-test="admin-users-filter-button"
        pButton
        (click)="toggleFilters($event)"
        aria-haspopup="dialog"
        #filterToggleButton
    >
        <!-- TODO: Replace inline SVG with reusable icons -->
        <svg xmlns="http://www.w3.org/2000/svg" class="material-symbol-svg" viewBox="0 -960 960 960" fill="currentColor"><path d="M440-160q-17 0-28.5-11.5T400-200v-240L168-736q-15-20-4.5-42t36.5-22h560q26 0 36.5 22t-4.5 42L560-440v240q0 17-11.5 28.5T520-160h-80Zm40-308 198-252H282l198 252Zm0 0Z"/></svg>
        {{('filterComponent.filterBtn.label' | transloco) + (totalfilters ? ' : ' + totalfilters : '')}}
    </button>

    <p-popover #filterPopover appendTo="body" styleClass="filter-popover" (onShow)="onPopoverShow()" (onHide)="onPopoverHide()">
        <div pFocusTrap
            #filterContent
            id="filter-popover-content"
            class="tw-outline-none tw-flex tw-flex-col tw-gap-4"
            tabindex="-1"
            role="dialog"
            aria-modal="true"
            aria-labelledby="filter-title"
        >
            <h2 id="filter-title" class="filter-title tw-m-0">{{ 'filterComponent.filterTitle' | transloco }}</h2>

            <div class="tw-flex tw-flex-col tw-gap-2">
                <div *ngFor="let filter of filterCollection; trackBy: trackByFilter">
                    @if (filter.value.type === 'select') {
                    <label [attr.for]="'filter-select-' + filter.key">{{ filter.value.label || (filter.key | titlecase) }}</label>
                    <p-select
                        [options]="filter.value.options"
                        [(ngModel)]="filterResponse[filter.key]"
                        optionLabel="name"
                        [attr.id]="'filter-select-' + filter.key"
                        [ariaLabel]="(filter.value.label || (filter.key | titlecase)) + ' filter'"
                        [showClear]="true"
                        fluid
                        appendTo="self"
                        [filter]="true"
                        filterBy="name"
                        (onFilter)="searchFilter($event, filter.key)"
                        [emptyFilterMessage]="'filterComponent.emptyFilter.message' | transloco"
                        [lazy]="true"
                        [placeholder]="filter.value.placeholder"
                        (onLazyLoad)="filter.value.total && $event.last < filter.value.total + batchSize ? loadMoreOptions($event, filter.key) : null"
                    />
                    } @else if(filter.value.type === 'multi-select') {
                    <label [attr.for]="'filter-multiselect-' + filter.key">{{ filter.value.label || (filter.key | titlecase) }}</label>
                    <p-multiselect
                        [options]="filter.value.options"
                        [(ngModel)]="filterResponse[filter.key]"
                        optionLabel="name"
                        [attr.id]="'filter-multiselect-' + filter.key"
                        [ariaLabel]="(filter.value.label || (filter.key | titlecase)) + ' filter'"
                        [showToggleAll]="filter.value.showSelectAll ?? false"
                        [showClear]="true"
                        [maxSelectedLabels]="1"
                        fluid
                        appendTo="self"
                        filterBy="name"
                        (onFilter)="searchFilter($event, filter.key)"
                        [emptyFilterMessage]="'filterComponent.emptyFilter.message' | transloco"
                        [lazy]="true"
                        [virtualScroll]="true"
                        [virtualScrollItemSize]="30"
                        [placeholder]="filter.value.placeholder"
                        (onLazyLoad)="filter.value.total && $event.last < filter.value.total + batchSize ? loadMoreOptions($event, filter.key) : null"
                    />
                    }
                </div>
            </div>

            <div class="tw-pt-4 filter-footer">
                <div class="tw-flex">
                    <p-checkbox name="save-filter" inputId="save-filter" [(ngModel)]="saveFilters" [binary]="true" aria-labelledby="save-filter-label" />
                    <label id="save-filter-label" for="save-filter" class="tw-ml-2">{{ 'filterComponent.saveFilter.label' | transloco }}</label>
                </div>

                <div class="tw-mt-4 tw-flex tw-justify-end tw-gap-2">
                    <p-button
                        data-test="admin-users-filter-cancel-button"
                        [label]="'filterComponent.cancelBtn.label' | transloco"
                        variant="text"
                        (onClick)="closeFilters()"
                    />
                    <p-button
                        data-test="admin-users-filter-apply-button"
                        [label]="'filterComponent.applyBtn.label' | transloco"
                        class="tw-whitespace-nowrap"
                        (onClick)="applyFilters()"
                    />
                </div>
            </div>
        </div>
    </p-popover>
</div>
